import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../../../environments/environment';
import { CustomerFilter } from '../../models/customer-filter';
import { HttpClient } from '@angular/common/http';
import { skip } from "rxjs/operators";

import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { AuctionFilter } from '../../models/auction-filter';
import { LoggingService } from '../../../../services/logging.service';

const apiServer = environment.apiServer;
declare var $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}


@Component({
  selector: 'app-home-main-modal-customer',
  templateUrl: './home-main-modal-customer.component.html',
  styleUrls: ['./home-main-modal-customer.component.sass']
})
export class HomeMainModalCustomerComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];
  private opened = false;

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('nameInput') nameInputModel: QueryList<any>;

  dt: DataTables.Api;
  modelCustomerFilter: CustomerFilter = new CustomerFilter();
  modelAuctionFilter: AuctionFilter = new AuctionFilter();
  dtOptionsCustomers: DataTables.Settings = {};
  dataSetCustomer: any;
  checkedCustomer: number[];

  constructor(
    private http: HttpClient, 
    private bus: BusAuctionFilterService,
    private loggingService: LoggingService,
    private cd: ChangeDetectorRef
  ) {
    this.checkedCustomer = [];
  }

  onFieldChange() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalCustomerComponent.onFieldChange', null, 'Field change started');
      
      this.dt.ajax.reload();
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalCustomerComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalCustomerComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }

  ngOnInit() {
    this.subs.push(
      this.bus.currentClearModalFilter$
        .pipe(skip(1))  // При инициализации фильтр уже очищен
        .subscribe(key => {
          if (key === 'contractor' || key === "all") {
            this.nameInputModel.forEach(function (item) {
              item.nativeElement.checked = false;
            });
            this.checkedCustomer = [];

            if (key !== "all") {
              this.onAuctionFilter();
            }
          }
        })
    );

    const that = this;
    
    $('#modalCustomers').off('shown.bs.modal').on('shown.bs.modal', function () {
      if (!that.opened) {
        that.opened = true;
        that.dt.ajax.reload();
      }
    });


    this.dtOptionsCustomers = {
      pagingType: 'full_numbers',
      pageLength: 250,
      serverSide: true,
      processing: true,
      autoWidth: false,
      dom: 'tip',
      order: [1],
      deferLoading: 0,
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: 'Нет совпадающих значений для поиска',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

        dataTablesParameters.ContractorName = this.modelCustomerFilter.contractorName;
        dataTablesParameters.ContractorINN = this.modelCustomerFilter.contractorINN;
        dataTablesParameters.ContractorKPP = this.modelCustomerFilter.contractorKPP;
        dataTablesParameters.ContractorLevel = this.modelCustomerFilter.contractorLevel;
        dataTablesParameters.ContractorType = this.modelCustomerFilter.contractorType;
        dataTablesParameters.ContractorOKOPF = this.modelCustomerFilter.contractorOKOPF;
        dataTablesParameters.ContractorCategory = this.modelCustomerFilter.contractorCategory;

        that.http.post<DataTablesResponse>(`${apiServer}/customer`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetCustomer = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
            that.cd.detectChanges();
          });
      },
      columns: [
        { orderable: false },
        { data: 'contractorName', name: 'contractorName' },
        { data: 'contractorINN', name: 'contractorINN' },
        { data: 'contractorKPP', name: 'contractorKPP' },
        { data: 'contractorLevel', name: 'contractorLevel' },
        { data: 'contractorType', name: 'contractorType' },
        { data: 'contractorOKOPF', name: 'contractorOKOPF' },
        { data: 'contractorCategory', name: 'contractorCategory' }
      ]
    };
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onSelectedRow(event, value) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalCustomerComponent.onSelectedRow', null, 'Row selection started');
      
      if (event.target.checked) {
        this.checkedCustomer.push(value);
      } else {
        for (let i = 0; i < this.checkedCustomer.length; i++) {
          if (this.checkedCustomer[i] === value) {
            this.checkedCustomer.splice(i, 1);
          }
        }
      }
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalCustomerComponent.onSelectedRow', null, 'Row selection completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalCustomerComponent.onSelectedRow', _error, null, 'Row selection failed');
      throw _error;
    }
  }

  onSelectingRows(event) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalCustomerComponent.onSelectingRows', null, 'Selecting all rows started');
      
      const that = this;

      this.nameInputModel.forEach(function (item) {
        item.nativeElement.checked = event.target.checked;

        if (event.target.checked) {
          that.checkedCustomer.push(item.nativeElement.value);
        } else {
          for (let i = 0; i < that.checkedCustomer.length; i++) {
            if (that.checkedCustomer[i] === item.nativeElement.value) {
              that.checkedCustomer.splice(i, 1);
            }
          }
        }
      });
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalCustomerComponent.onSelectingRows', null, 'Selecting all rows completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalCustomerComponent.onSelectingRows', _error, null, 'Selecting all rows failed');
      throw _error;
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }

  onAuctionFilter() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalCustomerComponent.onAuctionFilter', null, 'Auction filter started');
      
      this.modelAuctionFilter.contractor = this.checkedCustomer.join(',');
      this.bus.changeFilter(this.modelAuctionFilter);
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalCustomerComponent.onAuctionFilter', null, 'Auction filter applied');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalCustomerComponent.onAuctionFilter', _error, null, 'Auction filter failed');
      throw _error;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-customer/home-main-modal-customer.component.ts